import dayjs from 'dayjs';
import {
  sendImpersonatingDetailsToTelemetry,
  TLTRY_DEFAULTS,
} from 'legacy-src/utility/telemetry';
import { getSectionAndStudentName } from '.';

const postImpersonatingTelemetryData = ({
  eventType,
  sectionId,
  studentId,
  subjectId,
  userData,
  teacherClasses,
}) => {
  const {
    me: { initId: userId },
  } = userData;
  const { id: amUserId, pilot } = window.current_user || {};
  const { actualSectionId } = getSectionAndStudentName(
    studentId,
    sectionId,
    teacherClasses,
  );
  const data = {
    app: 'fym/impersonating',
    event_type: eventType,
    params: {
      impersonated_student_id: studentId,
    },
    user: {
      am_user_id: amUserId,
      pilot,
      cb_user_id: userId,
    },
    context: {
      subject_id: subjectId,
      class_id: actualSectionId,
    },
    timestamp: dayjs(),
  };
  sendImpersonatingDetailsToTelemetry(Object.assign(data, TLTRY_DEFAULTS[0]));
};

export default postImpersonatingTelemetryData;
